import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { Table, TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { CoreApiService } from '../../../core/service/core-api-service';
import { AppService } from '../../../core/service/app.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { properties } from '../../../../environments/properties';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-list-car-trip',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    DividerModule,
    CommonModule,
    CalendarModule,
    FormsModule,
    DropdownModule
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list-car-trip.component.html',
  styleUrl: './list-car-trip.component.css',
})
export class ListCarTripComponent implements OnInit{
  @ViewChild('dtCarTrip') table!: Table;
  titulo: string = 'Lista de Carreras';
  ltsCarTrips: any[] = [];
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
  ltsStates: any[] = [];
  filteredTrip: any[] = [];
  selectedState: any = null;
  companyId: string = '';

  constructor(private readonly apiService: CoreApiService, private readonly util: AppService) {}

  ngOnInit(): void {
    this.dateStart.setDate(this.dateEnd.getDate() - 10);
    this.getListCartrip();
    this.companyId = this.util.returnCompany();
  }

  getListCartrip(): void {
    const queryParams = {
      startDate: this.dateStart?.toISOString().split('T')[0],
      endDate: this.dateEnd?.toISOString().split('T')[0],
    };
    this.apiService.consumirWSGet(
      properties.serviceListCarTrip,
      queryParams,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsCarTrips = data.data;
          this.filteredTrip = this.ltsCarTrips;
          this.buildStates(this.ltsCarTrips);
          this.applyFilters();
        } else {
          this.util.mostrarToast(
            'Lista de carreras',
            'Error al obtener la lista de carreras',
            4
          );
        }
      }
    );
  }

  onStateChange() {
    this.applyFilters();
    if (this.table) {
      this.table.first = 0;
    }
  }

  private buildStates(users: any[]) {
    this.ltsStates = [
      { pd_name: 'Todos', pd_code: null },
      ...[...new Set(users.map((u) => u.pd_name))]
        .filter((name) => !!name)
        .map((name) => ({
          pd_name: name,
          pd_code: name,
        })),
    ];
  }

  applyFilters() {
    this.ltsCarTrips = [...this.filteredTrip];
    this.ltsCarTrips = this.ltsCarTrips.filter((carTrip) => {
      // filtro por ciudad
      const matchState = this.selectedState
        ? carTrip.pd_name === this.selectedState
        : true;

      // filtro por fecha
      const userDate = new Date(carTrip.car_tri_date);
      const matchStart = this.dateStart ? userDate >= this.dateStart : true;
      const matchEnd = this.dateEnd ? userDate <= this.dateEnd : true;

      return matchState && matchStart && matchEnd;
    });
  }

  exportToExcel() {
    const dataExport = this.ltsCarTrips.map((carTrip) => ({
      ID: carTrip.car_tri_id,
      Nombre: carTrip.usr_name,
      Apellido: carTrip.usr_last_name,
      Telefono: carTrip.usr_phone,
      'Fecha de carrera': this.formatearFecha(carTrip.car_tri_date),
      Estado: carTrip.st_name,
      Ciudad: carTrip.pd_name,
      'Placa Conductor': carTrip.car_tri_plate
        ? carTrip.car_tri_plate
        : 'Sin información',
      'Conductor Nombre': carTrip.dri_name
        ? carTrip.dri_name
        : 'Sin información',
      'Conductor Apellido': carTrip.dri_last_name
        ? carTrip.dri_last_name
        : 'Sin información',
      'Conductor Telefono': carTrip.dri_phone
        ? carTrip.dri_phone
        : 'Sin información',
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataExport);
    const workbook: XLSX.WorkBook = {
      Sheets: { Usuarios: worksheet },
      SheetNames: ['Usuarios'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, 'usuarios');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs.saveAs(data, `${fileName}_export_${new Date().getTime()}.xlsx`);
  }

  private formatearFecha(fecha: string | Date): string {
    if (!fecha) return '';
    const d = new Date(fecha);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const anio = d.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }
}
